export type { IRegionCity } from './dto/ResponseDto';

import { IRequest } from '@r1-frontend/shared/types/IRequest';

interface IRequestProps {
    id: number,
}
/*
* Список городов по региону
* https://master.api-content.sandbox.d2c.r-one.io/docs/v1#/%D0%93%D0%95%D0%9E/164d02eb7326ba38cccdca51fa2be3f7
*/

export const getCitiesByRegion = (providerId: number, queryParams: IRequestProps): IRequest => ({
    uri: '/v1/geography/get-cities-by-region',
    method: 'GET',
    headers: { 'ProviderId': `${providerId}` },
    queryParams,
});
